const isCNServer = () => SERVER_LOCATION === 'cn';

const isRuServer = () => SERVER_LOCATION === 'ru';

export { isCNServer, isRuServer };